import { InjectionToken, Signal } from '@angular/core';

import { Visit } from '@lib/core/models/visit.interface';

export const APPOINTMENTS_SIGNAL = new InjectionToken<Signal<Visit[] | null>>('APPOINTMENTS_SIGNAL');
